module.exports = __webpack_public_path__ + "media/app/assets/specializations/mage/fire-992f3f229fe8be68f8342a8141760910.png";